import { Download, FileDown } from "lucide-react";
import { toast } from "sonner";
import { api, errorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";

export function DocDownloadButtons({ doc, size = "icon", className = "h-8 w-8" }) {
  const original = async () => {
    try {
      await api.downloadOriginal(doc);
    } catch (e) {
      toast.error(errorDetail(e, "Dosya indirilemedi"), { duration: 8000 });
    }
  };
  const exportText = async () => {
    try {
      await api.exportText(doc);
    } catch (e) {
      toast.error(errorDetail(e, "Metin dışa aktarılamadı"), { duration: 8000 });
    }
  };
  const originalMissing = doc.original_available === false;
  return (
    <>
      <Button
        data-testid={`download-${doc.id}`}
        variant="ghost" size={size} className={className}
        onClick={original}
        disabled={originalMissing}
        title={originalMissing ? "Orijinal dosya sunucuda yok" : "Orijinal dosyayı indir"}
      >
        <Download className="h-4 w-4" />
      </Button>
      <Button
        data-testid={`export-${doc.id}`}
        variant="ghost" size={size} className={className}
        onClick={exportText}
        disabled={doc.status !== "ready"}
        title="İşlenmiş metni dışa aktar (.md)"
      >
        <FileDown className="h-4 w-4" />
      </Button>
    </>
  );
}
